import type { PointerEvent } from 'react';
import { PointerSensor } from '@dnd-kit/core';

/**
 * An extended "PointerSensor" that prevent some
 * interactive html element(button, input, textarea, select, option...) from dragging
 */

const isInteractiveElement = (element: Element | null) => {
	const interactiveElements = [
		'button',
		'input',
		'textarea',
		'select',
		'option',
		'svg',
		'label',
	];

	if (
		element?.tagName
        && interactiveElements.includes(element.tagName.toLowerCase())
	) {
		return true;
	}

	return false;
};

export class SmartPointerSensor extends PointerSensor {
	static activators = [
		{
			eventName: 'onPointerDown' as any,
			handler:   ({ nativeEvent: event }: PointerEvent) => {
				if (
					!event.isPrimary
                    || event.button !== 0
                    || isInteractiveElement(event.target as Element)
				) {
					return false;
				}

				return true;
			},
		},
	];
}
